<template>
  <div>
    <iframe className="sugestoes-box" id="box-sugestoes" title="sugestoes"
            src="https://azcronos.com.br/sugestoes/?categoria=7"/>
  </div>
</template>
<script>
export default {
  name: 'Sugestoes',
}
</script>

<style scoped lang="stylus">
iframe
  border 0px
  margin-left 0px
  height 1100px
  margin-top 0px
  width 100%
</style>
